import { connect } from 'react-redux';
import sortBy from 'lodash/sortBy';
import { excludeDeprecated } from 'common/ducks/categories';
import SubcategoriesField from 'common/components/sub_categories_field';

const mapStateToProps = ({ categories }) => {
  const cats = excludeDeprecated(categories.data).filter(cat => !cat.is_one_to_one);
  /* sub-categories grouped by category and sorted alphabetically */
  const groups = sortBy(cats, 'name').reduce((acc, cat) => {
    return {
      ...acc,
      [cat.name]: sortBy(cat.sub_categories, 'name')
    };
  }, {});

  return {
    categories: groups
  };
}

export default connect(mapStateToProps)(SubcategoriesField);



// WEBPACK FOOTER //
// ./common/containers/sub_categories_field.js